import '.bj{flex-shrink:0;}.ssr-plugin'
import '.bl{padding:1rem;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.bp{height:100%;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ba{background-color:transparent;}.ssr-plugin'
import '.ex{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.do{position:sticky;}.ssr-plugin'
import '.ey{top:4rem;}.ssr-plugin'
import '.ez{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.f0{padding-bottom:1rem;}.ssr-plugin'
import '.c{margin-bottom:1rem;}.ssr-plugin'
import '.f1{border-bottom:var(--blue-border);}.ssr-plugin'
import '.z{position:fixed;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.bo{right:0px;}.ssr-plugin'
import '.f2{bottom:0px;}.ssr-plugin'
import '.ek{z-index:9999;}.ssr-plugin'
import '.f3{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cx{justify-content:flex-end;}.ssr-plugin'
import '.cd{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bj bl a2 bp b9 ba ex"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e ab"
    >
      <div className="do ey ez ae f0 c f1 d"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="z cj bn bo f2 ek ae f3 d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bl d cx f1"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cd ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
